import FollowUpList from './FollowUpList';
export default FollowUpList;
